import {
  SET_JUMBOTRON_TITLE,
  SET_IS_LOADING,
  SET_SEARCH_LOADER
} from '../actions/common'

export function common(
  state = {
    title: '',
    isLoading: false,
    searchLoader: false
  },
  action
) {
  switch (action.type) {
    case SET_JUMBOTRON_TITLE: {
      return Object.assign({}, state, {
        title: action.title
      })
    }
    case SET_IS_LOADING: {
      return Object.assign({}, state, {
        isLoading: action.isLoading
      })
    }
    case SET_SEARCH_LOADER: {
      return Object.assign({}, state, {
        searchLoader: action.searchLoader
      })
    }
    default:
      return state
  }
}
